import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    // Define your global font sizes here
    fontFamily: "Manrope, sans-serif",
    fontWeightRegular: 400, // Corresponds to Regular
    fontWeightMedium: 500, // Corresponds to Medium
    fontWeightBold: 700, // Corresponds to Bold
    h1: {
        fontSize: '32px',
        fontWeight: 700,
    },
    h2: {
        fontSize: '24px',
        fontWeight: 400
    },
    h3: {

    },
    h4: {
        fontFamily: "Manrope, sans-serif",
         fontWeight: 700
    },

    h5: {
        fontSize: '16px',
        fontWeight: 400
    },
    body1: {
        fontSize: '16px',
        lineHeight: '22px',
        fontWeight: 400
    },
    body2: {
        fontSize: '16px',
        lineHeight: '22px',
        fontWeight: 400,
        color: '#111'
    },
    // Add other typography options here
  },
  palette: {
    // Define your global color palette here
    primary: {
      main: '#3A238C',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F0EDFA',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5',
    },
    text: {
      primary: '#111111',
    },
    success: {
      main: '#14AE5C',
    },
    error: {
      main: '#EC221F',
    }
    // Add other color options here
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // Styles applied to all buttons
          textTransform: 'none',
        },
        containedPrimary: {
          // Styles for primary variant
          backgroundColor: 'var(--brand-default-color)',
          color: '#fff',
          textTransform: 'none',
          borderRadius: '6px',
          padding: '10px 12px',
          minWidth: '100px',
          fontSize: '14px',
          fontWeight: 600,
          height: 38,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'var(--blue-blue-09)',
            boxShadow: 'none',
          },
          '&:disabled': {
            backgroundColor: 'var(--brand-white-default)',
            color: 'var(--text-default-disabled)',
            boxShadow: 'none',
            '& .MuiButton-startIcon > .MuiSvgIcon-root': {
              fontSize: 17,
              fill: 'var(--text-default-disabled)',
            }
          }
        },
        containedSecondary: {
          // Styles for secondary variant with bg blue
          border: '1px solid var(--brand-default-color)',
          borderRadius: '6px',
          color: 'var(--brand-default-color)',
          textTransform: 'none',
          padding: '10px 12px',
          minWidth: '100px',
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '14px',
          height: 38,
          background: 'var(--secondary-hover)',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'var(--brand-secondary-hover)',
            boxShadow: 'none',
          },
          '& .MuiButton-startIcon > .MuiSvgIcon-root': {
            fontSize: 17,
            fill: 'var(--brand-default-color)'
          },
          '&:disabled': {
            backgroundColor: 'var(--brand-white-default)',
            color: 'var(--text-default-disabled)',
            boxShadow: 'none',
            '& .MuiButton-startIcon > .MuiSvgIcon-root': {
              fontSize: 17,
              fill: 'var(--text-default-disabled)',
            }
          },
        },
        outlinedPrimary: {
          // Styles for outlined primary variant
          borderColor: 'var(--brand-default-color)',
          borderRadius: '6px',
          color: 'var(--brand-default-color)',
          textTransform: 'none',
          padding: '10px 12px',
          minWidth: '100px',
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '14px',
          height: 38,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'var(--secondary-hover)',
            boxShadow: 'none',
          },
          '& .MuiButton-startIcon > .MuiSvgIcon-root': {
            fontSize: 17,
          },
          '&:disabled': {
            backgroundColor: 'var(--brand-white-default)',
            color: 'var(--text-default-disabled)',
            boxShadow: 'none',
            '& .MuiButton-startIcon > .MuiSvgIcon-root': {
              fontSize: 17,
              fill: 'var(--text-default-disabled)',
            }
          }
        },
        outlinedSecondary: {
          // Styles for outlined secondary variant
          borderColor: 'none',
          border: 0,
          color: 'var(--brand-default-color)',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            color: 'var(--blue-blue-09)',
            border: 0,
            backgroundColor: 'none',
            boxShadow: 'none',
          },
          '&:disabled': {
            backgroundColor: 'none',
            color: 'var(--text-default-disabled)',
            boxShadow: 'none',
            border:0,
            '& .MuiButton-startIcon > .MuiSvgIcon-root': {
              fontSize: 17,
              fill: 'var(--text-default-disabled)',
            }
          }
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
         filledInfo: {
          backgroundColor: 'var(--green-2)',
          color: '#fff',
        },
      },
    },
  },
});

export default theme;